import { render, staticRenderFns } from "./CopTiposEvento.vue?vue&type=template&id=e9227d50&scoped=true"
import script from "./CopTiposEvento.vue?vue&type=script&lang=js"
export * from "./CopTiposEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9227d50",
  null
  
)

export default component.exports